import { render, staticRenderFns } from "./VehicleFound.vue?vue&type=template&id=2289297d&"
import script from "./VehicleFound.vue?vue&type=script&lang=js&"
export * from "./VehicleFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports